let inited = false;

export default async () => {
  if (!inited) {
    inited = true;
  }
};
